<template>
  <span v-html="text"></span>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    highlights: {
      type: [String, Array],
      default: () => {
        return []
      },
    },
  },
  mounted() {
    // console.log(this.highlights, this.value)
  },
  computed: {
    text: function () {
      if (!this.highlights) return this.value || ''

      const matches = (
        Array.isArray(this.highlights)
          ? this.highlights
          : this.highlights
          ? [this.highlights]
          : []
      ).map((h) => this.value.matchAll(new RegExp(h, 'gi')))

      const segments = matches
        .reduce((a, c) => a.concat([...c]), [])
        .map((m) => [m.index, m.index + m[0].length])
        .sort((a, b) => a[0] - b[0])

      let i = 0
      do {
        if (segments[i] && segments[i + 1]) {
          if (segments[i + 1][0] <= segments[i][1]) {
            // Consolidate segment i+1 with segment i by extending segment i and removing segment i+1.
            if (segments[i + 1][1] > segments[i][1])
              segments[i][1] = segments[i + 1][1]
            segments.splice(i + 1, 1)
          } else i++
        }
      } while (i < segments.length - 1)

      const segStrs = segments.map(([start, end]) =>
        this.value.slice(start, end)
      )

      const parts = []
      let remainder = this.value.slice()
      for (const segStr of segStrs) {
        const [left, ...rest] = remainder.split(segStr)
        parts.push(left, `<span class="secondary--text">${segStr}</span>`)
        remainder = rest.join(segStr)
      }
      parts.push(remainder)

      return parts.join('')
    },
  },
}
</script>
